// src/components/common/ErrorBoundary.js
// 44차: 크래시 방지용 ErrorBoundary — 앱 전체 다운 대신 에러 UI 노출
// 46차: Sentry.captureException 연동
// 51차: 색 theme.js 단일화 — COLORS 참조 / dev 메시지 빨강 통일

import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import * as Sentry from '@sentry/react-native';
import { COLORS } from '../../constants/theme';
import { WarningIcon } from './Icons';

const GOLD   = COLORS.gold;
const BG     = COLORS.bg;
const SURFACE = COLORS.surface;
const BORDER = COLORS.border;
const TEXT   = COLORS.text;
const TEXT_MUTED = COLORS.textMuted;
const RED    = COLORS.red;
const ON_GOLD = COLORS.onGold;

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // 46차: Sentry로 에러 전송
    Sentry.captureException(error, {
      extra: { componentStack: info?.componentStack },
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <View style={s.container}>
        <View style={s.card}>
          <WarningIcon size={s.emoji.fontSize || 40} color={RED} />
          <Text style={s.title}>잠시 문제가 발생했어요</Text>
          <Text style={s.desc}>
            일시적인 오류입니다.{'\n'}아래 버튼을 눌러 다시 시도해주세요.
          </Text>
          {__DEV__ && this.state.error?.message ? (
            <Text style={s.devMsg}>{this.state.error.message}</Text>
          ) : null}
          <TouchableOpacity style={s.btn} onPress={this.handleReset} activeOpacity={0.85}>
            <Text style={s.btnText}>다시 시도</Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  }
}

const s = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: BG,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  card: {
    backgroundColor: SURFACE,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: BORDER,
    padding: 28,
    alignItems: 'center',
    width: '100%',
    maxWidth: 360,
  },
  emoji: {
    fontSize: 44,
    marginBottom: 16,
  },
  title: {
    color: TEXT,
    fontSize: 18,
    fontWeight: '800',
    marginBottom: 10,
    textAlign: 'center',
  },
  desc: {
    color: TEXT_MUTED,
    fontSize: 14,
    textAlign: 'center',
    lineHeight: 22,
    marginBottom: 12,
  },
  devMsg: {
    color: RED,
    fontSize: 11,
    fontFamily: 'monospace',
    backgroundColor: COLORS.redBg,
    borderRadius: 6,
    padding: 10,
    width: '100%',
    marginBottom: 16,
  },
  btn: {
    marginTop: 8,
    backgroundColor: GOLD,
    borderRadius: 10,
    paddingVertical: 13,
    paddingHorizontal: 40,
  },
  btnText: {
    color: ON_GOLD,
    fontSize: 15,
    fontWeight: '800',
  },
});